import React from "react";
import Calendar from "../../Icons/Calendar";

// Custom Date Input for DatePicker
const CustomDateInput = React.forwardRef<
  HTMLDivElement,
  {
    value?: string;
    onClick?: () => void;
    disabled?: boolean;
    placeholder?: string;
  }
>(
  (
    { value, disabled = false, placeholder = "Select a date...", onClick },
    ref
  ) => {
    return (
      <div
        className="form-control w-100 d-flex gap-8 align-items-center justify-content-between"
        onClick={onClick}
        ref={ref}
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <div
          className={`d-flex gap-8 align-items-center ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          } ${!value ? "text-grey-medium" : ""}`}
        >
          <Calendar />
          {value || placeholder}
        </div>
        <svg
          className="min-w-12px"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="#757575"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  }
);

export default CustomDateInput;